import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../colorVars';
import ApplyRounding from '../../../../../../utils/math/ApplyRounding';
import { Body4 } from '../../../../../atomic/text/Text';
import { translateOptionSymbol } from '../../../../../../stores/websocketStore/utils/mungingUtils/translateOptionSymbol';
import determineSide from '../../../../../../utils/positions/DetermineSide';
import { dateStringTo24HourEST } from '../../../../../../stores/websocketStore/utils/mungingUtils/timeFormatting/dateStringTo24HourEST';
export const ExecutionsRow = ({ execution }) => {
  const {
    symbol,
    action,
    quantity,
    fillPrice,
    totalCost,
    commission,
    executionTime,
    quoteAtTimeOfOrder,
    underlyingQuoteAtTimeOfFill,
    reason,
  } = execution;
  const formattedTime = dateStringTo24HourEST(executionTime);
  const formatBidAsk = (string) => {
    const arr = string.split(' ');
    return arr[1] + '/' + arr[3];
  };
  return (
    <tr>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {symbol.length > 6 ? translateOptionSymbol(symbol) : symbol}
        </Body4>
      </td>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {determineSide(action)}
        </Body4>
      </td>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {quantity}
        </Body4>
      </td>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {ApplyRounding(fillPrice, 2)}
        </Body4>
      </td>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {ApplyRounding(totalCost, 2)}
        </Body4>
      </td>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {formattedTime}
        </Body4>
      </td>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {formatBidAsk(quoteAtTimeOfOrder)}
        </Body4>
      </td>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {formatBidAsk(underlyingQuoteAtTimeOfFill)}
        </Body4>
      </td>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {commission === 0 ? 'none' : commission}
        </Body4>
      </td>
      <td>
        <Body4 fontWeight={600} color={colors.lightGrey}>
          {reason}
        </Body4>
      </td>
    </tr>
  );
};

ExecutionsRow.propTypes = {
  execution: PropTypes.shape({
    action: PropTypes.string,
    commission: PropTypes.number,
    executionTime: PropTypes.string,
    fillPrice: PropTypes.number,
    quantity: PropTypes.number,
    quoteAtTimeOfOrder: PropTypes.string,
    reason: PropTypes.string,
    symbol: PropTypes.string,
    totalCost: PropTypes.number,
    underlyingQuoteAtTimeOfFill: PropTypes.string,
  }),
};
